
// import React from "react";
// import Progress from "../Progress";
// import AvatarGroup from "../AvatarGroup";
// import { LuPaperclip } from "react-icons/lu";
// import moment from "moment";

// moment.locale("fr");

// const TaskCard = ({
//   title,
//   description,
//   priority,
//   status,
//   progress,
//   createdAt,
//   dueDate,
//   assignedTo,
//   attachmentCount = 0,
//   completedTodoCount = 0,
//   todoCheckList = [],
//   onClick,
// }) => {
//   // Sécuriser todoCheckList
//   const totalTodos = Array.isArray(todoCheckList) ? todoCheckList.length : 0;
  

//   // Normalisation du status pour les couleurs et border
//   const normalizedStatus = status?.toLowerCase();

//   const getStatusTagColor = () => {
//     switch (normalizedStatus) {
//       case "encours":
//         return "text-cyan-500 bg-cyan-50 border border-cyan-500/10";
//       case "terminé":
//         return "text-lime-500 bg-lime-50 border border-lime-500/20";
//       case "enretard":
//         return "text-red-500 bg-red-50 border border-red-500/20";
//       default:
//         return "text-white bg-violet-500 border border-violet-500/20";
//     }
//   };

//   const getPriorityTagColor = () => {
//     switch (priority) {
//       case "faible":
//         return "text-emerald-500 bg-emerald-50 border border-emerald-500/10";
//       case "moyen":
//         return "text-amber-500 bg-amber-50 border border-amber-500/10";
//       default:
//         return "text-rose-500 bg-rose-50 border border-rose-500/10";
//     }
//   };

//   const getBorderColor = () => {
//     switch (normalizedStatus) {
//       case "encours":
//         return "border-cyan-500";
//       case "terminé":
//         return "border-indigo-500";
//       case "enretard":
//         return "text-red-500 bg-red-50 border border-red-500/20";
//       default:
//         return "border-violet-500";
//     }
//   };

//   return (
//     <div
//       className="bg-white rounded-xl py-4 shadow-md shadow-gray-100 border border-gray-200/50 cursor-pointer"
//       onClick={onClick}
//     >
//       <div className="flex items-end gap-3 px-4">
//         <div
//           className={`text-[11px] font-medium ${getStatusTagColor()} px-4 py-0.5`}
//         >
//           {status}
//         </div>
//         <div
//           className={`text-[11px] font-medium ${getPriorityTagColor()} px-4 py-0.5`}
//         >
//           priorité: {priority}
//         </div>
//       </div>

//       <div className={`px-4 border-l-[3px] ${getBorderColor()}`}>
//         <p className="text-sm font-medium text-gray-800 mt-4 line-clamp-2">
//           {title}
//         </p>
//         <p className="text-xs text-gray-500 mt-1.5 line-clamp-2 leading-[18px]">
//           {description}
//         </p>
//         <p className="text-[13px] text-gray-700/80 font-medium mt-2 mb-2 leading-[18px]">
//           Tâche accomplie{" "}
//           <span className="font-semibold text-gray-700">
//             {completedTodoCount}/{totalTodos}
//           </span>
//         </p>
//         <Progress progress={progress} status={status} />
//       </div>

//       <div className="px-4">
//         <div className="flex items-center justify-between">
//           <label className="text-xs text-gray-500">Date de début</label>
//           <p className="text-[13px] font-medium text-gray-900">
//             {createdAt ? moment(createdAt).format("Do MMM YYYY") : "-"}
//           </p>
//         </div>
//         <div className="flex items-center justify-between">
//           <label className="text-[13px] font-medium text-gray-500">
//             Date d'échéance
//           </label>
//           <p className="text-[13px] font-medium text-gray-900">
//             {dueDate ? moment(dueDate).format("Do MMM YYYY") : "-"}
//           </p>
//         </div>
//         <div className="flex items-center justify-between mt-3">
//           <AvatarGroup avatars={assignedTo || []} />
//           {attachmentCount > 0 && (
//             <div className="flex items-center gap-2 bg-blue-50 px-2.5 py-1.5 rounded-lg">
//               <LuPaperclip className="text-blue-600" />
//               <span className="text-xs text-gray-900">{attachmentCount}</span>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TaskCard;
import React from "react";
import Progress from "../Progress";
import AvatarGroup from "../AvatarGroup";
import { LuPaperclip } from "react-icons/lu";
import moment from "moment";

moment.locale("fr");

const TaskCard = ({
  title = "",
  description = "",
  priority = "faible",
  status = "enattente",
  progress = 0,
  createdAt = null,
  dueDate = null,
  assignedTo = [],
  attachmentCount = 0,
  completedTodoCount = 0,
  todoCheckList = [],
  onClick = () => {},
}) => {

  // Sécuriser todoCheckList
  const totalTodos = Array.isArray(todoCheckList) ? todoCheckList.length : 0;

  const normalizedStatus = status?.toLowerCase();

  const getStatusTagColor = () => {
    switch (normalizedStatus) {
      case "encours":
        return "text-cyan-500 bg-cyan-50 border border-cyan-500/10";
      case "terminé":
        return "text-lime-500 bg-lime-50 border border-lime-500/20";
      case "enretard":
        return "text-red-500 bg-red-50 border border-red-500/20";
      default:
        return "text-white bg-violet-500 border border-violet-500/20";
    }
  };

  const getPriorityTagColor = () => {
    switch (priority) {
      case "faible":
        return "text-emerald-500 bg-emerald-50 border border-emerald-500/10";
      case "moyen":
        return "text-amber-500 bg-amber-50 border border-amber-500/10";
      default:
        return "text-rose-500 bg-rose-50 border border-rose-500/10";
    }
  };

  const getBorderColor = () => {
    switch (normalizedStatus) {
      case "encours":
        return "border-cyan-500";
      case "terminé":
        return "border-indigo-500";
      case "enretard":
        return "text-red-500 bg-red-50 border border-red-500/20";
      default:
        return "border-violet-500";
    }
  };

  return (
    <div
      className="bg-white rounded-xl py-4 shadow-md shadow-gray-100 border border-gray-200/50 cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-end gap-3 px-4">
        <div
          className={`text-[11px] font-medium ${getStatusTagColor()} px-4 py-0.5`}
        >
          {status || "-"}
        </div>
        <div
          className={`text-[11px] font-medium ${getPriorityTagColor()} px-4 py-0.5`}
        >
          priorité: {priority || "-"}
        </div>
      </div>

      <div className={`px-4 border-l-[3px] ${getBorderColor()}`}>
        <p className="text-sm font-medium text-gray-800 mt-4 line-clamp-2">
          {title}
        </p>
        <p className="text-xs text-gray-500 mt-1.5 line-clamp-2 leading-[18px]">
          {description}
        </p>
        <p className="text-[13px] text-gray-700/80 font-medium mt-2 mb-2 leading-[18px]">
          Tâche accomplie{" "}
          <span className="font-semibold text-gray-700">
            {completedTodoCount}/{totalTodos}
          </span>
        </p>
        <Progress progress={progress} status={status} />
      </div>

      <div className="px-4">
        <div className="flex items-center justify-between">
          <label className="text-xs text-gray-500">Date de début</label>
          <p className="text-[13px] font-medium text-gray-900">
            {createdAt ? moment(createdAt).format("Do MMM YYYY") : "-"}
          </p>
        </div>
        <div className="flex items-center justify-between">
          <label className="text-[13px] font-medium text-gray-500">
            Date d'échéance
          </label>
          <p className="text-[13px] font-medium text-gray-900">
            {dueDate ? moment(dueDate).format("Do MMM YYYY") : "-"}
          </p>
        </div>
        <div className="flex items-center justify-between mt-3">
          <AvatarGroup avatars={Array.isArray(assignedTo) ? assignedTo : []} />
          {attachmentCount > 0 && (
            <div className="flex items-center gap-2 bg-blue-50 px-2.5 py-1.5 rounded-lg">
              <LuPaperclip className="text-blue-600" />
              <span className="text-xs text-gray-900">{attachmentCount}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskCard;

